module.exports = __webpack_public_path__ + "img/mechanical-technology.706ccd25.svg";